module.exports = __webpack_public_path__ + "static/media/0024_IMG_LE_FROMAGER_TRAD.1cef38eb.png";